import styles from "./rule-of-72.module.css"

import React from "react"
import * as shared from "activities/components/shared"
import * as util from "activities/util"
import * as inputs from "activities/components/inputs"
import * as callouts from "activities/components/callouts"
import assign from "object-assign"

export default shared.ActivityFactory(
  ({getState, getProps, updateState}) => {
    const {years, resetKey} = getState()
    const {id} = getProps()
    const rate72 = util.get72(years)
    return (
      <div>
        <shared.Content className={styles["content"]}>
          <shared.Calculator className={styles["calculator"]}>
            <inputs.Input id="rule-72" size="big" title="Years" valueType="years" value={years} onChange={updateState("years", util.digitsOnly)} />
          </shared.Calculator>
        </shared.Content>
        <callouts.Callout>
          <callouts.Detail label="Rule of 72 Estimate" result={rate72 == Infinity ? "--%" : `${util.round(rate72, 2)}%`} dataTestId="rule-of-72-estimate" />
        </callouts.Callout>
      </div>
    )
  },
  {
    stateFilter: (state) => {
      const {years} = state
      return assign(state, {rate: util.round(util.get72(years) / 100, 4)})
    },
    defaultProps: {
      id: "rule-of-72",
      className: "rule-of-72",
      title: "Rule of 72 by Years",
      subtitle: "See what interest rate you would need to double your investment by the number of years you enter."
    },
    defaultState: {
      years: 10
    }
  }
)
